import dispatcher from "../dispatcher";
import { invoiceConstant } from "../constants/constants";
import rq from "../components/utility/rq.js";
export function createInvoice(invoiceData) {
    rq.postJson("/api/v1/invoice", invoiceData)
    .then((data) => {
        var { invoice } = invoiceData;
        invoice.invoiceId = data[0].id;
        dispatcher.dispatch({ type: invoiceConstant.INVOICE_CREATED, invoice });
    }).catch((err) => {
        console.log("err...............",err);
        dispatcher.dispatch({ type: invoiceConstant.INVOICE_CREATION_FAILED, msg: `creating invoice ${invoiceData.invoice.invoiceNumber} failed !` });
    });

}





// WEBPACK FOOTER //
// ./src/jsx/actions/invoice-action.jsx